import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./styles/tailwind.css";

// Start the mocking conditionally.
if (
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_MOCK_SERVER
) {
  const { worker } = require("./__mocks__/browser");
  worker.start();
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
